module.exports = __webpack_public_path__ + "static/media/RU.267d97db.svg";